"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ViewWebhookManager () {
        return ViewWebhookManager;
    },
    get ViewWebhookManagerBuilder () {
        return ViewWebhookManagerBuilder;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _ncError = require("~/helpers/ncError");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ViewWebhookManagerBuilder = class ViewWebhookManagerBuilder {
    withModelManager(modelWebhookManager) {
        this.modelWebhookManager = modelWebhookManager;
        return this;
    }
    withModel(model) {
        this.modelId = model.id;
        return this;
    }
    async withModelId(modelId) {
        this.modelId = modelId;
        return this;
    }
    async withView(view) {
        this.oldView = view;
        return this;
    }
    async withViewId(viewId, req) {
        // needed to prevent circular dependencies
        const viewsV3Service = _Noco.default.nestApp.get('IViewsV3Service');
        this.oldView = await viewsV3Service.getView(this.context, {
            viewId,
            req
        }, this.ncMeta);
        return this;
    }
    forCreate() {
        if (!this.modelId) {
            _ncError.NcError.get(this.context).internalServerError(`Need to call 'withModel' before running 'forCreate'`);
        }
        return new ViewWebhookManager(this.context, {
            action: _nocodbsdk.WebhookActions.INSERT,
            modelId: this.modelId,
            modelWebhookManager: this.modelWebhookManager
        }, this.ncMeta);
    }
    forUpdate() {
        if (!this.modelId) {
            _ncError.NcError.get(this.context).internalServerError(`Need to call 'withModel' before running 'forUpdate'`);
        }
        return new ViewWebhookManager(this.context, {
            action: _nocodbsdk.WebhookActions.UPDATE,
            modelId: this.modelId,
            oldView: this.oldView,
            modelWebhookManager: this.modelWebhookManager
        }, this.ncMeta);
    }
    forDelete() {
        if (!this.modelId) {
            _ncError.NcError.get(this.context).internalServerError(`Need to call 'withModel' before running 'forDelete'`);
        }
        return new ViewWebhookManager(this.context, {
            action: _nocodbsdk.WebhookActions.DELETE,
            modelId: this.modelId,
            oldView: this.oldView,
            modelWebhookManager: this.modelWebhookManager
        }, this.ncMeta);
    }
    constructor(context, ncMeta){
        this.context = context;
        this.ncMeta = ncMeta;
    }
};
let ViewWebhookManager = class ViewWebhookManager {
    withNewView(view) {
        this.params.newView = view;
        return this;
    }
    async withNewViewId(viewId, req) {
        // needed to prevent circular dependencies
        const viewsV3Service = _Noco.default.nestApp.get('IViewsV3Service');
        this.params.newView = await viewsV3Service.getView(this.context, {
            viewId,
            req
        }, this.ncMeta);
        return this;
    }
    getViewId() {
        var _ref;
        var _this_params_oldView, _this_params_newView;
        return (_ref = (_this_params_oldView = this.params.oldView) == null ? void 0 : _this_params_oldView.id) != null ? _ref : (_this_params_newView = this.params.newView) == null ? void 0 : _this_params_newView.id;
    }
    emit() {}
    constructor(context, params, ncMeta){
        this.context = context;
        this.params = params;
        this.ncMeta = ncMeta;
        this.emitted = false;
    }
};
